import styled from 'styled-components';
import { BoxButton } from '@riac/design-system';

export const PostCommentBlock = styled.div`
  border: 1px solid ${(props) => props.theme.black[95]};
  background: rgba(255,255,255,0.025);
  margin: 10px 0;
  padding: 20px 40px;
`;

export const PostCommentTitle = styled.h3`
  font-size: 3rem;
`;

export const PostCommentGravatar = styled.img`
  width: 30px;
  margin-right: 15px;
`;

export const CommentHeader = styled.header`
  display: flex;
  margin: 15px 0;

  p {
    font-size: 1.8rem;
  }
`;

export const CommentLength = styled.div`
  text-align: right;
  font-size: 1.4rem;
  margin-top: -5px;
`;

export const CommentText = styled.textarea`
  resize: vertical;
  margin-bottom: 0;
  padding: 5px;
  font-size: 2rem;
  line-height: 1.2 ;
  min-height: 100px;
`;

export const CommentSubmit = styled(BoxButton)`
  padding: 5px 15px;
  margin-top: -10px;
`;

export const CommentCancel = styled(BoxButton)`
  background: none;
  color: rgba(255, 255, 255, 0.65);
  font-size: 1.6rem;
  padding: 5px 10px;
  margin: 5px;

  &:hover {
    color: ${({ theme }) => theme.gold[50]}
  }
`;

export const GravatarLink = styled.p`
  font-size: 1.4rem;
  color: ${(props) => props.theme.black[40]};
`;
